export default __webpack_public_path__ + "static/media/arrowRight.956d575c.svg";